import { Survey } from '../../models/survey';

type AGSReportState = {
  yearSelected: Survey
}

export const state: AGSReportState = {
    yearSelected: {} as Survey
}

export const mutations = {
  SET_YEAR_SELECTED(state: AGSReportState, payload: Survey) {
    state.yearSelected = payload
  },
}

export const actions = {
  changeYearSelected({ commit }: any, payload: Survey) {
    commit('SET_YEAR_SELECTED', payload)
  },
}

export const getters = {
  getYearSelected: (state: AGSReportState) => state.yearSelected,
}